module.exports = __webpack_public_path__ + "static/media/CB_engagement_16.1453545f.jpg";